import { ChangeDetectionStrategy, Component, Input, OnDestroy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { QueryBuilderConfig, RuleSet } from 'angular2-query-builder';
import { FieldMap } from 'angular2-query-builder/dist/components';
import * as _ from 'lodash';
import { OPERATOR_LABELS, OPERATOR_MAP } from 'shared/modules/query-builder/query-builder-utils';

@Component({
  selector: 'app-query-builder',
  templateUrl: './query-builder.component.html',
  styleUrls: ['./query-builder.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class QueryBuilderComponent implements OnDestroy {
  readonly operatorMap = OPERATOR_MAP;
  readonly operatorLabels = OPERATOR_LABELS;
  readonly emptyMessage = 'QUERY_BUILDER.empty_group';

  private _query = new UntypedFormControl({ condition: 'and', rules: [] });

  get query(): UntypedFormControl {
    return this._query;
  }

  private _fields: FieldMap = {};
  private _sourceFields: FieldMap = {};
  private readonly _languageChanges = this.translateService.onLangChange.subscribe(() => {
    this._fields = _.cloneDeep(this._sourceFields);
  });

  @Input() set fields(fields: FieldMap) {
    this._sourceFields = fields;
    this._fields = _.cloneDeep(fields);
  }

  constructor(private translateService: TranslateService) { }

  ngOnDestroy(): void {
    this._languageChanges.unsubscribe();
  }

  @Input() set ruleSet(ruleSet: RuleSet) {
    this._query.setValue(_.cloneDeep(ruleSet));
  }

  get config(): QueryBuilderConfig {
    return { fields: this._fields };
  }

  get value(): RuleSet {
    return this._query.value;
  }
}
